import { render, staticRenderFns } from "./TemThree.vue?vue&type=template&id=13ea9eab&scoped=true&"
import script from "./TemThree.vue?vue&type=script&lang=js&"
export * from "./TemThree.vue?vue&type=script&lang=js&"
import style0 from "./TemThree.vue?vue&type=style&index=0&id=13ea9eab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea9eab",
  null
  
)

export default component.exports